import { startOfDay } from 'date-fns';

import { cleanDate, dateStrToDate } from '../../../utils/datetimeUtils';

// BE expects the date in the agent locale format: 31/12/2026 for UK and FR
const API_DATE_FORMAT = {
	day: 'numeric',
	month: 'numeric',
	year: 'numeric',
};

export const formatCancellationDate = (formatDate, cancellationDate) =>
	cancellationDate
		? cleanDate(formatDate(new Date(cancellationDate), API_DATE_FORMAT))
		: null;

export const getRefundDateBoundaries = (seasonStartDate, dateFormatString) => {
	const parsedStartDate =
		seasonStartDate && dateFormatString
			? dateStrToDate(seasonStartDate, dateFormatString)
			: null;

	return {
		minRefundDate: parsedStartDate ? startOfDay(parsedStartDate) : null,
		maxRefundDate: startOfDay(new Date()),
	};
};

export const isRefundDateInRange = (
	refundDate,
	{ minRefundDate, maxRefundDate },
) => {
	if (!refundDate) {
		return true;
	}

	const date = new Date(refundDate);

	if (Number.isNaN(date.getTime())) {
		return false;
	}

	const day = startOfDay(date);

	if (maxRefundDate && day > maxRefundDate) {
		return false;
	}

	if (minRefundDate && day < minRefundDate) {
		return false;
	}

	return true;
};
